import React, { useState } from 'react';
import Swal from 'sweetalert2';
import '../../css/modal.css';
import { changeUserPassword } from '../../utils/passwordUtils';

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatNewPassword, setRepeatNewPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    if (newPassword.length < 6) {
      setError('La nueva contraseña debe tener al menos 6 caracteres.');
      setIsSubmitting(false);
      return;
    }

    if (newPassword !== repeatNewPassword) {
      setError('Las nuevas contraseñas no coinciden.');
      setIsSubmitting(false);
      return;
    }

    try {
      const result = await changeUserPassword(currentPassword, newPassword);
      if (result.success) {
        Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: result.message,
        });
        setCurrentPassword('');
        setNewPassword('');
        setRepeatNewPassword('');
        onClose();
      } else {
        if (result.message === 'La contraseña actual es incorrecta') {
          setError('Contraseña actual incorrecta');
        } else {
          setError(result.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: result.message,
        });
      }
    } catch (error) {
      setError('Error al actualizar la contraseña');
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al actualizar la contraseña',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h2 className="text-xl font-bold mb-4">Cambiar Contraseña</h2>
        <form onSubmit={handlePasswordChange} className="space-y-4">
          <div>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Contraseña actual"
              className="w-full p-2 border rounded"
              required
              disabled={isSubmitting}
            />
            {error && error !== 'Contraseña actual incorrecta' && (
              <p className="incorrect">{error}</p>
            )}
            {error === 'Contraseña actual incorrecta' && (
              <p className="incorrect">Contraseña actual incorrecta</p>
            )}
          </div>
          <div>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Nueva Contraseña"
              className="w-full p-2 border rounded"
              required
              disabled={isSubmitting}
              minLength={6}
            />
          </div>
          <div>
            <input
              type="password"
              value={repeatNewPassword}
              onChange={(e) => setRepeatNewPassword(e.target.value)}
              placeholder="Repetir Nueva Contraseña"
              className="w-full p-2 border rounded"
              required
              disabled={isSubmitting}
              minLength={6}
            />
            <p className="text-sm text-gray-600 mt-1">
              La nueva contraseña debe tener al menos 6 caracteres.
            </p>
          </div>
          <div className="flex justify-end space-x-2 btn-container-area">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:text-gray-800"
              disabled={isSubmitting}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Actualizando...' : 'Cambiar Contraseña'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
